import React from 'react'
import classNames from 'classnames'

import { ProgressBar } from 'components/UI/ProgressBar/ProgressBar'

import AverageRating from './AverageRating'
import RatingCount from './RatingCount'
import RatingLabel from './RatingLabel'
import { RatingsProps } from './types'

import styles from './ReviewStats.module.css'

export type ReviewStatsProps = {
  ratings: Record<RatingsProps, number>
  className?: string
}

const ratingKeys = [5, 4, 3, 2, 1] as RatingsProps[]

const ReviewStats: React.FC<ReviewStatsProps> = ({ ratings, className }) => {
  const numberOfRatings = Object.values(ratings).reduce(
    (acc, val) => acc + val,
    0,
  )
  const sumOfAllRatings = ratingKeys.reduce(
    (acc, val) => acc + val * ratings[val],
    0,
  )

  return (
    <div className={classNames(styles.ratingContainer, className)}>
      <AverageRating
        numberOfRatings={numberOfRatings}
        sumOfAllRatings={sumOfAllRatings}
      />
      <div className={styles.detailsContainer}>
        {ratingKeys.map((stars) => (
          <React.Fragment key={stars}>
            <RatingLabel stars={stars} />
            <ProgressBar
              percent={(ratings[stars] * stars * 100) / sumOfAllRatings}
            />

            <RatingCount ratingCount={ratings[stars]} />
          </React.Fragment>
        ))}
      </div>
    </div>
  )
}

export { ReviewStats as default, ReviewStats }
